/** Fires after a task or note was changed or deleted from an edit popup, so whatever is on screen
 * can refetch (`useQueueDelivered` listens for it alongside the offline queue's). */
export const ITEM_EDITED_EVENT = "efss:item-edited";
